export enum EmailTemplatePermissions {
  ALL = "Travel:EmailTemplates:*",
  READ = "Travel:EmailTemplates:Read",
  WRITE = "Travel:EmailTemplates:Write",
}

export enum AirlinePermissions {
  ALL = "Travel:Airlines:*",
  READ = "Travel:Airlines:Read",
  WRITE = "Travel:Airlines:Write",
}

export function hasEmailTemplateAccess(userPermissions: string[]): boolean {
  const permissions = [
    EmailTemplatePermissions.READ.toString(),
    EmailTemplatePermissions.WRITE.toString(),
    EmailTemplatePermissions.ALL.toString(),
    "*",
  ];
  return userPermissions.some((permission) => permissions.includes(permission));
}
